import { NumberId } from 'src/app/shared/state/number-id.model';

export interface Edge extends NumberId {
  vertex_a: number;
  vertex_b: number;
  geom_distance: number;
  user_distance: number;
  edge_class: EdgeClass;
  va_latitude: number;
  va_longitude: number;
  vb_latitude: number;
  vb_longitude: number;
  properties: object | UndergroundProperties;
}

export function createEdge(params: Partial<Edge>) {
  let properties;
  if (params.edge_class === EdgeClass.U) {
    properties = createUndergroundProperties({});
  } else {
    properties = {};
  }
  return {
    properties,
    ...params
  } as Edge;
}

export enum EdgeClass {
  A = 'A',
  U = 'U',
  L = 'L'
}

export interface UndergroundProperties {
  'duct_diameter': number;
  'subduct_diameter': number;
  'installation_base': 'soil' | 'concret';
  'ducts': DuctProperties[][];
}

export interface DuctProperties {
  occupied: boolean;
  subducts?: SubductProperties[];
}

export interface SubductProperties {
  occupied: boolean;
}

export function createUndergroundProperties(params: Partial<UndergroundProperties>): UndergroundProperties {
  return {
    ducts: [[]],
    installation_base: 'soil',
    ...params
  } as UndergroundProperties;
}
